import ScheduleDoctorsLpu from 'www/modules/Schedule/classes/ScheduleDoctorsLpu'

export default () => {
  new ScheduleDoctorsLpu({
    doctorPageType: 'doctor-list',
    dataItem: 'data-schedule-item-lpu-doctors',
    dataStorage: 'data-schedule-storage-lpu-doctors',
    selectorContainersSlots: '.b-doctor-card__appointment-calendar',
  })
}
